import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useExpandedFdocContext } from '../ExpandedFdocProvider.js';
import { styled } from 'styled-components';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import Tooltip from '@fabric-app/ui/components/Tooltip';
import SimilarItemsInlineButton from '../../../../Tiptap/Components/SimilarItemsInlineButton.js';
import { SummarizeInlineButton } from '../../../../assistant/components/SummarizeInlineButton.js';

const Toolbar = styled.div.withConfig({
  displayName: "PDFToolbar__Toolbar",
  componentId: "sc-3ec620ef-0"
})([
  `user-select:none;display:inline-flex;padding:4px;align-items:flex-start;gap:4px;z-index:130;border-radius:10px;background:#fff;position:fixed;top:0;left:0;transform:translate(-50%,-50%);`
]);
const PDFToolbar = ({ innerDivRef }) => {
  const { onGetSimilarItemsToText, onSummarizeText } = useExpandedFdocContext();
  const { isMobile } = useResponsive();
  const [toolbarPosition, setToolbarPosition] = useState(null);
  const [currentTextSize, setCurrentTextSize] = useState(0);
  const [toolbarRef, setToolbarRef] = useState(null);
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const onMouseDown = (e) => {
      if (!toolbarRef?.contains(e.target)) {
        setHidden(true);
      }
    };
    const onMouseUp = (_) => {
      setHidden(false);
    };
    window.addEventListener("mousedown", onMouseDown, true);
    window.addEventListener("mouseup", onMouseUp, true);
    return () => {
      window.removeEventListener("mousedown", onMouseDown, true);
      window.removeEventListener("mouseup", onMouseUp, true);
    };
  }, [
    toolbarRef
  ]);
  useEffect(() => {
    if (!innerDivRef || isMobile()) return;
    const onSelectionChange = (_) => {
      const selection = window.getSelection();
      if (!selection) {
        setToolbarPosition(null);
        return;
      }
      if (!innerDivRef.contains(selection.anchorNode)) {
        setToolbarPosition(null);
        return;
      }
      if (selection.type !== "Range") {
        setToolbarPosition(null);
        return;
      }
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();
      const top = rect.top - 20;
      const left = rect.left + rect.width / 2;
      setToolbarPosition({
        top,
        left
      });
      const textSize = selection.toString().length;
      setCurrentTextSize(textSize);
    };
    document.addEventListener("selectionchange", onSelectionChange);
    return () => {
      document.removeEventListener("selectionchange", onSelectionChange);
    };
  }, [
    innerDivRef,
    isMobile
  ]);
  const handleOnGetSimilarItemsToText = () => {
    const selection = window.getSelection();
    if (!selection) return;
    const text = selection.toString();
    onGetSimilarItemsToText(text);
    setToolbarPosition(null);
  };
  const handleOnSummarizeText = () => {
    const selection = window.getSelection();
    if (!selection) return;
    const text = selection.toString();
    onSummarizeText(text);
    setToolbarPosition(null);
  };
  const isSimilarDisabled = currentTextSize > 1e3;
  if (isMobile() || hidden) return null;
  return toolbarPosition && /* @__PURE__ */ createPortal(/* @__PURE__ */ jsxs(Toolbar, {
    ref: setToolbarRef,
    style: {
      top: toolbarPosition.top,
      left: toolbarPosition.left
    },
    children: [
      /* @__PURE__ */ jsx(Tooltip, {
        label: isSimilarDisabled ? "This highlight is too long, please highlight less than 1000 characters." : "See similar items",
        children: /* @__PURE__ */ jsx("div", {
          children: /* @__PURE__ */ jsx(SimilarItemsInlineButton, {
            onClick: handleOnGetSimilarItemsToText,
            disabled: isSimilarDisabled
          })
        })
      }),
      /* @__PURE__ */ jsx(SummarizeInlineButton, {
        onClick: handleOnSummarizeText
      })
    ]
  }), document.querySelector("#tooltip-portal") ?? document.body);
};

export { PDFToolbar as default };
//# sourceMappingURL=PDFToolbar.js.map
